import { Link } from "react-router-dom";
import { useStore } from "@/store/StoreContext";
import { WishlistButton } from "@/components/WishlistButton";
import { formatIDR } from "@/lib/format";

export const ProductCard = ({ product, index = 0 }) => {
  const { addToCart } = useStore();

  return (
    <article
      className="fade-up group"
      style={{ animationDelay: `${Math.min(index, 8) * 90}ms` }}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative overflow-hidden bg-linen">
        <Link to={`/produk/${product.slug}`} aria-label={product.name}>
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="aspect-square w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
          />
        </Link>
        <WishlistButton
          product={product}
          className="absolute right-3 top-3 h-9 w-9 bg-paper/90 backdrop-blur-sm"
          testId={`card-wishlist-${product.slug}`}
        />
        <button
          onClick={() => addToCart(product)}
          className="absolute inset-x-3 bottom-3 translate-y-3 bg-ink py-3 text-[11px] tracking-[0.2em] uppercase text-paper opacity-0 transition-[opacity,transform] duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100"
          data-testid={`card-add-to-cart-${product.slug}`}
        >
          Tambah ke Pilihan
        </button>
      </div>

      <div className="mt-5">
        <p className="label-eyebrow text-[9px] text-sand">{product.collection_name}</p>
        <Link to={`/produk/${product.slug}`}>
          <h3 className="mt-2 font-display text-xl leading-snug text-ink">{product.name}</h3>
        </Link>
        <p className="mt-1 text-xs text-stone">{product.color}</p>
        <p
          className="mt-3 text-sm font-medium tracking-wide text-ink"
          data-testid={`product-price-${product.slug}`}
        >
          {formatIDR(product.price)}
        </p>
        <button
          onClick={() => addToCart(product)}
          className="mt-4 w-full border border-ink py-3 text-[11px] uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-ink hover:text-paper md:hidden"
          data-testid={`mobile-add-to-cart-${product.slug}`}
        >
          Tambah ke Pilihan
        </button>
      </div>
    </article>
  );
};
